export default __webpack_public_path__ + "static/media/wheel-button.6ba700ae.png";